import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MosqueIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mosque"}/>
}
